import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import Footer from "@/components/Footer";
import FloatingUserMenu from "@/components/FloatingUserMenu";
import DiveCenterCard from "@/components/DiveCenterCard";
import WaveDivider from "@/components/WaveDivider";
import ScrollReveal from "@/components/ScrollReveal";
import SEO from "@/components/SEO";
import { BACKEND_URL } from '@/utils/apiConfig';

const API = `${BACKEND_URL}/api`;

const PartnerDiveCenters = () => {
  const navigate = useNavigate();
  const [diveCenters, setDiveCenters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const fetchDiveCenters = async () => {
      try {
        const response = await axios.get(`${API}/map/dive-centers`);
        setDiveCenters(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dive centers:', error);
        setLoading(false);
      }
    };

    fetchDiveCenters();
  }, []);

  return (
    <div className="min-h-screen">
      <SEO 
        title="Partner Dive Centers - George Dives Worldwide Locations"
        description="Explore our partner dive centers around the world where George teaches."
        keywords={['partner dive centers', 'dive centers worldwide', 'PADI centers']}
      />
      
      <Navigation />
      <FloatingUserMenu />

      <HeroSection 
        title="Partner Dive Centers,"
        subtitle="Worldwide Network"
        description="Explore our network of professional diving centers across the globe."
        backgroundColor="from-blue-700 via-cyan-600 to-teal-600"
      />

      <WaveDivider variant="smooth" />

      <section className="py-12">
        <div className="container mx-auto px-4 max-w-7xl">
          {loading ? (
            <div className="text-center py-20">
              <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-cyan-500 mx-auto mb-4"></div>
              <p>Loading dive centers...</p>
            </div>
          ) : diveCenters.length === 0 ? (
            <div className="text-center py-20">
              <p>No dive centers found.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {diveCenters.map((center, idx) => (
                <ScrollReveal key={center.id} animation="fade-up" delay={idx * 120} duration={700}>
                  <DiveCenterCard 
                    diveCenterInfo={center} 
                    onViewMap={() => navigate(`/map?center=${center.id}`)} 
                  />
                </ScrollReveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PartnerDiveCenters;
